import { ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import { BOOKING_TYPE } from '@Store/booking/types';
import { KeyboardEvent, MouseEvent } from 'react';
import { Link } from 'react-router-dom';

import styles from './styles';

const NewBookingPopper = ({ open, anchorEl, closePopper }: any) => {
    const classes = styles();
    const handleClose = (event: MouseEvent<EventTarget>) => {
        if (anchorEl && anchorEl.contains(event.target as HTMLElement)) {
            return;
        }

        closePopper();
    };

    function handleListKeyDown(event: KeyboardEvent) {
        if (event.key === 'Tab') {
            event.preventDefault();
            closePopper();
        }
    }

    return (
        <Popper open={open} anchorEl={anchorEl} role={undefined} transition disablePortal>
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    }}>
                    <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                                autoFocusItem={open}
                                id="menu-list-grow"
                                onKeyDown={handleListKeyDown}>
                                <MenuItem
                                    component={Link}
                                    to={{
                                        pathname: '/bookings/add',
                                        state: { type: BOOKING_TYPE.RETAIL },
                                    }}
                                    classes={{
                                        root: classes.newBookingMenuListItem,
                                    }}
                                    onClick={handleClose}>
                                    Retail Booking
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to={{
                                        pathname: '/bookings/add',
                                        state: { type: BOOKING_TYPE.AGENT },
                                    }}
                                    classes={{
                                        root: classes.newBookingMenuListItem,
                                    }}
                                    onClick={handleClose}>
                                    Travel Agent Booking
                                </MenuItem>
                                <MenuItem
                                    component={Link}
                                    to={{
                                        pathname: '/bookings/add',
                                        state: { type: BOOKING_TYPE.CORPORATE },
                                    }}
                                    classes={{
                                        root: classes.newBookingMenuListItem,
                                    }}
                                    onClick={handleClose}>
                                    Corporate Booking
                                </MenuItem>
                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>
    );
};

export default NewBookingPopper;
